import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { FileTypeIcon } from '@/components/shared/file-type-icon';
import {
  fileTypeFromName,
  formatFileSize,
} from '@/components/shared/file-type-icon/file-type';
import type { AcademicStatusDocument } from '@/models/learning/academic-situation';

interface AttachmentCardProps {
  document: AcademicStatusDocument;
}

export const AttachmentCard = ({ document }: AttachmentCardProps) => {
  const type = fileTypeFromName(document.filename);
  const typeLabel = type ? `${type.toUpperCase()} • ` : '';

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        p: 2,
        borderRadius: 2,
        border: ({ palette }) => `1px solid ${palette.neutral[200]}`,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} minWidth={0}>
        <FileTypeIcon type={type} />
        <Box minWidth={0}>
          <Typography variant="h3" noWrap>
            {document.filename}
          </Typography>
          <Typography variant="body2" color="neutral.500">
            {typeLabel}
            {formatFileSize(document.byte_size)}
          </Typography>
        </Box>
      </Stack>
      <IconButton
        component="a"
        href={document.url}
        target="_blank"
        rel="noopener"
        download
        aria-label={`Baixar ${document.filename}`}
      >
        <FileDownloadOutlined />
      </IconButton>
    </Stack>
  );
};
